module.exports = __webpack_public_path__ + "img/dea-formazione-ico-la-scuola-e.3f8cd929.svg";